@use '@lib/assets/styles/main.scss' as *;

.sidebar {
  // height: Calc(100% + 8px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 -16px;
}

.header {
  padding: 16px 16px 0;
  margin: 0 -16px;
}

.searchContainer {
  flex-shrink: 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search {
  flex: 1 1 auto;
}

.listContainer {
  flex: 1;
  overflow: hidden;
  margin: 0 -12px;
  padding: 0 12px;
}

.list {
  @include scrollStyles;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  padding: 0 16px 16px;
}

.listItem {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: $gray100;
  }

  &Selected {
    background-color: $blue50;

    &:hover {
      background-color: $blue50;
    }
  }
}

.listItemIcon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background-color: $blue50;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.listItemImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.listItemFavicon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.listItemAttachment {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.listItemMaterialIcon {
  font-size: 12px;
  line-height: inherit;
  text-align: center;
  color: $blue500;
}

.listItemContent {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.listItemTitle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $gray900;
  padding: 1.5px 0;
}

.listItemDescription {
  overflow: hidden;
  text-overflow: ellipsis;
  color: $gray700;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.emptyList {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.emptyText {
  color: $gray500;
  text-align: center;
}

.loadingMore {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
